import React, { useState, useRef, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import RepairServices from "../../../services/RepairServices";
import ApprovalOrRejectedModalSuperAdminModal from "./ApprovalOrRejectedModalSuperAdminModal";

const SuperAdminApproval = () => {
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const stores = user?.data?.user?.store || [];
  const defaultStore = stores[0]?._id || "";

  const [selectedStore, setSelectedStore] = useState(defaultStore);
  const [repairs, setRepairs] = useState([]);
  const [selectedRepair, setSelectedRepair] = useState("");
  const [items, setItems] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [loading, setLoading] = useState(false);
  const [run, setRun] = useState(0);

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);

  const sort = 50;
  const activePag = useRef(0);

  const handleApiError = (err) => {
    console.error("API ERROR:", err);
    Swal.fire({
      icon: "error",
      title: "Error",
      text:
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong while fetching data.",
    });
  };

  // FETCH REPAIR REQUESTS
  useEffect(() => {
    if (!selectedStore) return;

    setLoading(true);

    RepairServices.getRequest(selectedStore, "adminSubmit")
      .then((res) => {
        const list = res?.data?.data || [];
        setRepairs(list);
        setSelectedRepair(list.length > 0 ? list[0]._id : "");
      })
      .catch(handleApiError)
      .finally(() => setLoading(false));
  }, [selectedStore]);

  // FETCH ITEMS — fixed missing dependency
  useEffect(() => {
    if (!selectedRepair) {
      setItems([]);
      return;
    }

    setLoading(true);

    RepairServices.getAllItem(selectedRepair, "approvedByAdmin", selectedStore)
      .then((res) => {
        const arr = res?.data?.data || [];
        const filtered = arr.filter((i) => i.status === "approvedByAdmin");
        setItems(filtered);
      })
      .catch(handleApiError)
      .finally(() => setLoading(false));
  }, [selectedRepair, selectedStore, run]);

  const openEditModal = (item) => {
    setSelectedItem(item);
    setShowEditModal(true);
  };

  // APPROVE / LOCAL / REJECT HANDLER (No Transfer)
  const handleApproval = (item, status) => {
    const needRemark = status === "rejected";

    Swal.fire({
      title: `Confirm ${status}?`,
      text: `Repair No: ${item?.repairOrder?.repairOrderNo} | Part: ${item?.repairOrder?.inventory?.masterItem?.partNo}`,
      icon: needRemark ? "warning" : "success",
      showCancelButton: true,
      input: needRemark ? "textarea" : null,
      inputPlaceholder: "Enter remarks...",
      inputValidator: (v) => {
        if (needRemark && !v) return "Remarks required!";
      },
    }).then((result) => {
      if (!result.isConfirmed) return;

      const remark = needRemark ? result.value : "";

      RepairServices.updateItem(item._id, {
        status,
        approveQty: item.qtyRequired,
        adminRemark: remark,
      })
        .then(() => {
          Swal.fire("Success", `Item ${status} successfully`, "success");
          setRun((prev) => prev + 1);
        })
        .catch(handleApiError);
    });
  };

  const pagination = Math.ceil(items.length / sort);

  const onClickPage = (i) => {
    activePag.current = i;
  };

  useEffect(() => {
    activePag.current = 0;
  }, [items]);

  return (
    <>
      {showEditModal && (
        <ApprovalOrRejectedModalSuperAdminModal
          show={showEditModal}
          item={selectedItem}
          handleClose={() => setShowEditModal(false)}
          onSuccess={() => setRun((prev) => prev + 1)}
        />
      )}

      <div className="row">
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
            <div>Loading...</div>
          </div>
        ) : (
          <div className="col-xl-12">

            {/* FILTER BOX */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link to="#" onClick={() => setOpen(!open)}>
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>

              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">

                      <div className="col-6">
                        <label>Select Store</label>
                        <select
                          className="form-select"
                          value={selectedStore}
                          onChange={(e) => setSelectedStore(e.target.value)}
                        >
                          {stores.map((store) => (
                            <option key={store._id} value={store._id}>
                              {store.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-6">
                        <label>Select Repair</label>
                        <select
                          className="form-select"
                          value={selectedRepair}
                          onChange={(e) => setSelectedRepair(e.target.value)}
                        >
                          {repairs.map((r) => (
                            <option key={r._id} value={r._id}>
                              {r.repairOrderNo}
                            </option>
                          ))}
                        </select>
                      </div>

                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* TABLE */}
            <div className="filter cm-content-box box-primary mt-2">
              <div className="content-title">
                <div className="cpa">
                  <i className="fa fa-list me-2"></i>
                  Pending Approval
                  <span className="badge bg-orange ms-2">{items.length}</span>
                </div>
                <div className="tools">
                  <Link to="#" onClick={() => setOpen2(!open2)}>
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">

                  <div style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "420px",
                    whiteSpace: "nowrap"
                  }}>
                    <table className="table table-bordered table-striped">
                      <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 5 }}>
                        <tr>
                          <th>S.No</th>
                          <th>Repair No</th>
                          <th>Inventory Part No</th>
                          <th>Inventory Description</th>
                          <th>Repair Part No</th>
                          <th>Repair Description</th>
                          <th>Requested Qty</th>
                          <th>Edit</th>
                          <th>PO</th>
                          <th>Local</th>
                          <th>Reject</th>
                        </tr>
                      </thead>

                      <tbody>
                        {items.length > 0 ? (
                          items
                            .slice(activePag.current * sort, (activePag.current + 1) * sort)
                            .map((item, idx) => {
                              const inv = item?.repairOrder?.inventory;
                              const master = item?.masterlist;

                              return (
                                <tr key={item._id}>
                                  <td>{activePag.current * sort + idx + 1}</td>
                                  <td>{item?.repairOrder?.repairOrderNo}</td>
                                  <td>{inv?.masterItem?.partNo}</td>
                                  <td className="scrollable-description">{inv?.masterItem?.description}</td>
                                  <td>{master?.partNo || "-"}</td>
                                  <td className="scrollable-description">{master?.description || "-"}</td>
                                  <td>{item.qtyRequired}</td>

                                  <td>
                                    <button className="btn btn-primary btn-xs sharp"
                                      onClick={() => openEditModal(item)}>
                                      <i className="fa fa-pencil"></i>
                                    </button>
                                  </td>

                                  <td>
                                    <button className="btn btn-success btn-xs"
                                      onClick={() => handleApproval(item, "approved")}>
                                      <i className="fa fa-check"></i>
                                    </button>
                                  </td>

                                  <td>
                                    <button className="btn btn-info btn-xs"
                                      onClick={() => handleApproval(item, "local")}>
                                      <i className="fa fa-shopping-cart"></i>
                                    </button>
                                  </td>

                                  <td>
                                    <button className="btn btn-danger btn-xs"
                                      onClick={() => handleApproval(item, "rejected")}>
                                      <i className="fa fa-times"></i>
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center">No Items Found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* PAGINATION */}
                  <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                    <div className="dataTables_info">
                      Showing {activePag.current * sort + 1} to{" "}
                      {Math.min(items.length, (activePag.current + 1) * sort)} of{" "}
                      {items.length} entries
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers">
                      <Link
                        to="#"
                        className="paginate_button previous"
                        onClick={() =>
                          activePag.current > 0 && onClickPage(activePag.current - 1)
                        }
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </Link>

                      <span>
                        {Array.from({ length: pagination }, (_, i) => (
                          <Link
                            key={i}
                            to="#"
                            className={`paginate_button ${
                              activePag.current === i ? "current" : ""
                            }`}
                            onClick={() => onClickPage(i)}
                          >
                            {i + 1}
                          </Link>
                        ))}
                      </span>

                      <Link
                        to="#"
                        className="paginate_button next"
                        onClick={() =>
                          activePag.current + 1 < pagination &&
                          onClickPage(activePag.current + 1)
                        }
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </Link>
                    </div>
                  </div>

                </div>
              </Collapse>
            </div>

          </div>
        )}
      </div>
    </>
  );
};

export default SuperAdminApproval;
